import { render, staticRenderFns } from "./yututanchaung.vue?vue&type=template&id=3c70c9f2&scoped=true"
import script from "./yututanchaung.vue?vue&type=script&lang=js"
export * from "./yututanchaung.vue?vue&type=script&lang=js"
import style0 from "./yututanchaung.vue?vue&type=style&index=0&id=3c70c9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70c9f2",
  null
  
)

export default component.exports